<template>
  <div class="page-product">
    <h1>Order Page</h1>
  </div>
</template>
<script>
import OrderPageService from '../../service/vue/components/pages/OrderPageService';

export default {
  name: 'OrderPage',

  mounted() {
    OrderPageService.handle();
  },
};
</script>
